// 全站翻译公共入口：模块只注册字段；保持原有语言归一化、回退与插值规则。
import { messageModules } from "./modules.js";
export const messages = Object.freeze(
  Object.fromEntries(
    ["zh-HK", "zh-CN", "en-US"].map((locale) => [
      locale,
      Object.freeze(
        Object.assign(
          {},
          ...Object.values(messageModules).map((module) => module[locale])
        )
      ),
    ])
  )
);
export const UI_LOCALES = Object.freeze(["zh-CN", "en-US", "zh-HK"]);

export const normalizeUiLocale = (value) => {
  const code = String(value || "")
    .trim()
    .toLowerCase();
  if (code === "en" || code.startsWith("en-")) return "en-US";
  if (code === "zh-hk" || code === "zh-hant" || code === "zh-hant-hk")
    return "zh-HK";
  if (
    code === "zh" ||
    code === "zh-cn" ||
    code === "zh-hans" ||
    code.startsWith("zh-hans-")
  )
    return "zh-CN";
  return null;
};

export const translate = (locale, key, params = {}) => {
  const selected = messages[normalizeUiLocale(locale) || "zh-CN"];
  const template = selected[key] ?? messages["zh-CN"][key];
  if (template === undefined) return "—";
  return template.replace(/\{([a-zA-Z][a-zA-Z0-9]*)\}/g, (_, name) =>
    Object.prototype.hasOwnProperty.call(params, name)
      ? String(params[name])
      : `{${name}}`
  );
};

const NAVIGATION_ROUTES = Object.freeze({
  "/": "nav.home",
  "/home": "nav.home",
  "/pc/home": "nav.home",
  "/pc/featured": "nav.featured",
  "/pc/bid": "nav.bidding",
  "/bid": "nav.bidding",
  "/pc/clue": "nav.supply",
  "/info": "nav.supply",
  "/pc/info": "nav.supply",
  "/pc/supply-demand/hall": "nav.supply",
  "/pc/wiki": "nav.wiki",
  "/wiki": "nav.wiki",
  "/pc/brand": "nav.brands",
  "/brand": "nav.brands",
  "/pc/myai": "nav.ai",
  "/myai": "nav.ai",
  "/cart": "nav.trade",
  "/pc/myxg": "nav.mine",
  "/pc/user": "nav.mine",
  "/user": "nav.mine",
  "/pc/about": "nav.news",
  "/pc/pricechannel/display": "nav.priceChannel",
  "/source/publish": "nav.publish",
  "/pc/source/publish": "nav.publish",
  "/pc/source/publish/fast": "nav.publish",
  "/source/publish/fast": "nav.publish",
});

const NAVIGATION_TITLES = Object.freeze({
  首页: "nav.home",
  精选: "nav.featured",
  竞标: "nav.bidding",
  竞价: "nav.bidding",
  百科: "nav.wiki",
  芯片百科: "nav.wiki",
  品牌: "nav.brands",
  供需: "nav.supply",
  供求: "nav.supply",
  发布: "nav.publish",
  行情: "nav.priceChannel",
  行情指数: "nav.priceChannel",
  价格指数: "nav.priceChannel",
  先搜AI: "nav.ai",
  "先搜 AI": "nav.ai",
  交易: "nav.trade",
  我的: "nav.mine",
});

export const navigationMessageKey = (url, title) => {
  const sourceUrl = String(url || "").trim();
  const path =
    sourceUrl
      .split(/[?#]/)[0]
      .replace(/\/$/, "")
      .toLowerCase() || "/";
  if (sourceUrl && Object.prototype.hasOwnProperty.call(NAVIGATION_ROUTES, path))
    return NAVIGATION_ROUTES[path];
  const label = String(title || "").trim();
  return Object.prototype.hasOwnProperty.call(NAVIGATION_TITLES, label)
    ? NAVIGATION_TITLES[label]
    : null;
};
